import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

interface IContainer {
  isLarge?: boolean;
}

export const Container = styled.div<IContainer>`
  padding: 24px;
  width: 100%;
  max-width: ${({ isLarge }) => (isLarge ? '442px' : '379px')};
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s linear;
  transform: scale(1);
  display: flex;
  flex-direction: column;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  color: #1b203a;
  font-size: 18px;
  font-weight: 600;
  flex: 1;
`;

export const Back = styled.img`
  cursor: pointer;
`;

export const SubLabel = styled.div`
  font-size: 10px;
  color: #696f8c;
`;

export const Line = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 28px;
  flex: 1;
`;

interface IConfirm {
  disabled?: boolean;
}

export const Confirm = styled.button<IConfirm>`
  height: 36px;
  padding: 0 16px;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#fff')};
  background-color: ${({ disabled }) => (disabled ? '#edeff4' : '#1371FE')};
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const Cancel = styled.button`
  height: 36px;
  padding: 0 16px;
  color: #474d66;
  background: none;
  font-weight: 500;
  margin-right: 10px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  &.pictureInputs {
    width: 100%;
    margin-bottom: 24px;
  }

  &.pictureInputsWithLegend {
    width: 100%;
    margin-bottom: 8px;
  }

  &.progressRow {
    width: 100%;
    height: 22px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FileName = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: #474d66;
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  border: 1px solid #d8dae5;
`;

export const IconCloseAwesome = styled(FontAwesomeIcon)`
  position: absolute;
  background: white;
  width: 24px !important;
  padding: 1px 6px;
  right: 0px;
  cursor: pointer;
`;

export const ProfileImg = styled.img`
  width: 62px;
  height: 62px;
  border-radius: 32px;

  margin-right: 24px;
  object-fit: cover;
`;

export const Form = styled.form`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

interface IDivider {
  height?: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
`;

export const SpacingDivider = styled.div`
  width: 16px;
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
`;

export const FileImage = styled.img`
  width: 12px;
  height: 16px;
`;

export const HolderDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 22px;
`;

export const TextsRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 28px;
`;

export const TextsItem = styled.div`
  flex: 1;
  & + & {
    margin-left: 4px;
  }
`;

export const TextTitle = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #474d66;
`;

export const TextDescription = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #474d66;
  margin-top: 4px;
`;

export const Label = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #474d66;
  margin-top: 24px;
  margin-bottom: 8px;
`;

export const Input = styled.input`
  padding: 0px 16px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 42px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #474d66;
  margin-bottom: 16px;
`;

interface ICheckbox {
  active: boolean;
}

export const Checkbox = styled.div<ICheckbox>`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  border: ${({ active }) =>
    active ? '4px solid #1371fe' : '1px solid #d8dae5'};
  background-color: #fff;
  transition: 0.2s;
`;

export const CheckDivider = styled.div`
  height: 16px;
`;

export const CheckContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckText = styled.div`
  margin-left: 12px;
  font-weight: 500;
  font-size: 14px;
  color: #474d66;
`;

export const CheckTextHelp = styled.div`
  margin-left: 4px;
  font-weight: 300;
  font-size: 12px;
  color: #696f8c;
`;

export const CheckTextDescription = styled.div`
  margin-left: 28px;
  margin-top: 4px;
  font-weight: 400;
  font-size: 12px;
  color: #696f8c;

  b {
    font-size: 12px;
    font-weight: 500;
  }

  p {
    font-size: 12px;
  }

  i {
    font-size: 12px;
    font-style: italic;
  }
`;

export const WarningContainer = styled.div`
  margin-right: 8px;
  height: 20px;
`;

export const Description = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #474d66;
  margin-top: 28px;
`;

export const Close = styled.div`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 5px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const TextsRowFlex = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  margin-top: 28px;
  border-radius: 8px;
  padding: 10px 0px;
`;

export const TextsRowFlexItem = styled.div``;

export const ErrorStatus = styled.label``;

export const ToolTipText = styled.p`
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #ffffff;
  margin: unset;
`;

export const AssetInfo = styled.div`
  margin-top: 28px;
  border-radius: 8px;
  padding: 10px 12px;
  background: #f5f7fb;
`;

export const AssetInfoTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ProductName = styled.div`
  color: #474d66;
  font-size: 14px;
  font-weight: 500;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Internal = styled.div`
  color: #8f95b2;
  font-size: 12px;
  font-weight: 400;
  margin-left: 20px;
`;

export const AssetInfoBottom = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const AssetInfoLabel = styled.div`
  color: #8f95b2;
  font-size: 12px;
  font-weight: 400;

  div {
    font-size: 12px;
  }
`;

export const AssetInfoContent = styled.div`
  margin-left: 20px;
  color: #474d66;
  font-size: 12px;
  font-weight: 400;
  flex: 1;

  div {
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;

    span {
      font-size: 12px;
      color: #8f95b2;
    }
  }
`;
